/**
 * Copyright (C) 2019 Egylis,
 * Siège social, 83 bis rue de l'Abbé Groult, 75015 Paris - France.
 * All Rights Reserved.
 *
 * E-mail : info@egylis.com
 *
 * This software is the confidential and proprietary information
 * of Egylis. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only
 * in accordance with the terms of the license agreement you
 * entered into with Egylis.
 *
 * Created on Mon Feb 28 2022 16:48:22 GMT+0100 (heure normale d’Europe centrale).
 *
 * Version : Generator 2.0.9 / Datatable 1.0.1
 */

import {MOEntity} from './MOEntity';
import {Lang} from './ranges';


/**
 * Traduction Entity.
 */
export class I18n extends MOEntity {
    /**
     * Code
     */
    private _code: string;
    /**
     * Étiquette
     */
    private _label: string;
    /**
     * Description (html)
     */
    private _description: string;
    /**
     * Langue
     */
    private _lang: Lang;

    /**
     * Method called before the creation
     */
    protected createBefore(): void {
    }

    /**
     * Method called before the update
     */
    protected synchroBefore(): void {
    }

    /**
     * Method called before the synchronization
     */
    protected updateBefore(): void {
    }

    /**
     * Getter Code
     */
    public get code(): string {
        return this._code;
    }

    /**
     * Setter Code
     */
    public set code(value: string) {
        this._code = value;
    }

    /**
     * Getter Étiquette
     */
    public get label(): string {
        return this._label;
    }

    /**
     * Setter Étiquette
     */
    public set label(value: string) {
        this._label = value;
    }

    /**
     * Getter Description (html)
     */
    public get description(): string {
        return this._description;
    }

    /**
     * Setter Description (html)
     */
    public set description(value: string) {
        this._description = value;
    }

    /**
     * Getter Langue
     */
    public get lang(): Lang {
        return this._lang;
    }

    /**
     * Setter Langue
     */
    public set lang(value: Lang) {
        this._lang = value;
    }

}
